// extracted by mini-css-extract-plugin
export default {"wrapper":"customer_wrapper__vBwKu"};